import React from 'react'
import {reduxForm, formValueSelector} from 'redux-form'
import validate from './validations/validate'
import { CSSTransitionGroup } from 'react-transition-group'
import BillingInformation from './components/common/billingInformation'
import asyncValidate from './validations/asyncValidate'
import i18n from './translations/i18n';
import { connect } from 'react-redux';

const selector = formValueSelector('davron')

let DavronFormFourthPage = props => {
	const {handleSubmit, pristine, previousPage, submitting} = props
	let lng = props.lng;
	let btnValue = submitting ? i18n.t('button.submitting', {lng}) : i18n.t('button.submit', {lng})
	return (
		<form onSubmit={handleSubmit}>
			<CSSTransitionGroup
				transitionName="davron"
				transitionEnterTimeout={500}
				transitionLeaveTimeout={300}
			>
			
				<BillingInformation
					lng={lng}
					userType={props.userType}
					countries={props.countries}
					billingCountry={props.billingCountry}
					shippingAddressFilled={props.shippingAddressFilled}
					sameAddress={props.sameAddress}
					shippingaddressline1={props.shippingaddressline1}
					shippingpostalcode={props.shippingpostalcode}
					shippingcity={props.shippingcity}
					shippingCountry={props.shippingCountry}
					service={props.service}
					certification={props.certification}
					sameAddressChange={props.sameAddressChange}
					coupon={props.coupon}
					referral_sources={props.referral_sources}
					referral_source={props.referral_source}
				/>

			</CSSTransitionGroup>
			<div>
				<button type="button" className="btn btn-orange previous" onClick={previousPage}>{i18n.t('button.previous', {lng})}</button>
				<button type="submit" className="btn btn-orange submit" disabled={pristine || props.invalid || submitting} onClick={handleSubmit}>{btnValue}</button>
			</div>
		</form>
	)
}

DavronFormFourthPage = connect(
	(state, props) => ({
		service: selector(state, 'service'),
		certification: selector(state, 'certification'),
		userType: selector(state, 'userType'),
		billingCountry: selector(state, 'billingCountry'),
		sameAddress: selector(state, 'sameAddress'),
		shippingaddressline1: selector(state, 'shippingaddressline1'),
		shippingpostalcode: selector(state, 'shippingpostalcode'),
		shippingcity: selector(state, 'shippingcity'),
		shippingCountry: selector(state, 'shippingCountry'),
		referral_source: selector(state, 'referral_source')
	})
)(DavronFormFourthPage)

export default reduxForm({
	form: 'davron',
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate,
	asyncValidate,
	asyncBlurFields: ['couponCode']
})(DavronFormFourthPage)


// WEBPACK FOOTER //
// ./src/DavronFormFourthPage.js